(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('action-form-set-pristine', actionFunc);

    function actionFunc(FormBuilderService, $q, lodash) {
        return function(options) {
            $q.when(run());

            function run() {
                const fbService = FormBuilderService.get(options.form_name);
                if (!lodash.isEmpty(fbService)) {
                    fbService.eventsService.setPristine();
                }
            }
        };
    }
})();